import Component from 'cartware-component';
import { get, values, merge } from 'lodash';
import $script from 'scriptjs';
import Config from 'cartware-config';

/* eslint-disable */
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["domready"] }] */
export default class extends Component {
  domready() {

    const cropperRootObject = get(window, 'abcropper');

    window.cropperConfiguration = merge(get(cropperRootObject, 'configuration'), get(cropperRootObject, ['products', Config.get('product.id')]));

    values(get(cropperRootObject, 'assets.css')).map(url => this.loadCSS(url));

    const scriptPaths = ['runtime', 'polyfills', 'styles', 'scripts', 'vendor', 'main'].map(key => get(cropperRootObject, ['assets', 'js', key]));
    this.loadScripts(scriptPaths, () => {
      // cool
    });
  }

  loadScripts(scripts, cb) {
    const currentScript = scripts.shift();
    $script(currentScript, () => {
      if (scripts.length) {
        this.loadScripts(scripts, cb);
      } else {
        cb();
      }
    });
  }

  loadCSS(url) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = url;
    document.getElementsByTagName('HEAD')[0].appendChild(link);
  }
}
